/**
 * Pathname prefixes for the `app/(public)/` route group — public marketing pages
 * that should NOT receive Amplitude session replay or heavy autocapture
 * (formInteractions, elementInteractions, networkTracking, webVitals,
 * frustrationInteractions). Manual `trackEvent()` calls and basic session +
 * attribution autocapture stay on so marketing-funnel analytics still work.
 *
 * Derived from `app/(public)/**\/page.tsx`. The `[searchPage]` catch-all is
 * intentionally not listed — unknown root-level pathnames keep full
 * instrumentation; add specific prefixes here if a new public page is created
 * outside this list.
 */
export const PUBLIC_ROUTE_PREFIXES = [
  "/",
  "/how-to",
  "/blog",
  "/about",
  "/features",
  "/product",
  "/changelog",
  "/getting-started",
  "/intellectual-property",
  "/refund-policy",
  "/terms-of-service",
  "/unsubscribe",
  "/privacy-policy",
  "/alternatives",
] as const;

export function isPublicMarketingRoute(pathname: string | null): boolean {
  if (!pathname) return false;
  if (pathname === "/") return true;
  for (const prefix of PUBLIC_ROUTE_PREFIXES) {
    if (prefix === "/") continue;
    if (pathname === prefix) return true;
    if (pathname.startsWith(`${prefix}/`)) return true;
  }
  return false;
}
